import { useTranslation } from 'react-i18next';
import { Dialog, Spinner } from '@platform/ui';
import type { IFilePreviewDialogProps } from './IFilePreviewDialogProps';

/**
 * Вікно перегляду файлу (UIUX field-types/file, layout/dialogs, розмір lg): шапка — ім'я файлу, «Перегляд файлу», «Завантажити», ×;
 * тіло — зображення в межах вікна або PDF у вбудованому переглядачі браузера; поки вміст завантажується — індикатор, невдача — текст.
 */
export function FilePreviewDialog({ preview, onClose, onDownload }: IFilePreviewDialogProps) {
  const { t } = useTranslation();
  const { file, kind, url, error } = preview;
  return (
    <Dialog title={file.fileName} subtitle={t('recordPage.files.previewTitle')} size="lg" onClose={onClose}
      actions={<button type="button" className="rtab-file__btn" onClick={() => onDownload(file)}>{t('recordPage.files.download')}</button>}>
      <div className="rtab-preview" aria-busy={!url && !error}>
        {error && <p className="rtab-preview__error" role="alert">{error}</p>}
        {!error && !url && <Spinner />}
        {url && kind === 'image' && <img className="rtab-preview__img" src={url} alt={file.fileName} />}
        {url && kind === 'pdf' && <iframe className="rtab-preview__pdf" src={url} title={file.fileName} />}
      </div>
    </Dialog>
  );
}
